"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { jobDetailPath, parseJobParam, type JobType } from "@/utils/jobsPublic";

export function LegacyJobQueryRedirect({
  lang,
  openJobs,
}: Readonly<{
  lang: string;
  openJobs: ReadonlyArray<{ type: JobType; id: string }>;
}>) {
  const router = useRouter();
  const openJobKeys = openJobs.map((job) => `${job.type}:${job.id}`).join(",");

  useEffect(() => {
    const job = parseJobParam(new URLSearchParams(window.location.search).get("job"));
    if (!job) return;
    const isOpen = openJobKeys.split(",").includes(`${job.type}:${job.id}`);
    if (isOpen) {
      router.replace(jobDetailPath(job, lang));
    }
  }, [lang, openJobKeys, router]);

  return null;
}
